import user1Image from '../assets/img/users/100_1.jpg';
import user2Image from '../assets/img/users/100_2.jpg';
import user3Image from '../assets/img/users/100_3.jpg';
import user4Image from '../assets/img/users/100_4.jpg';

export const notificationsData = [
  {
    id: 1,
    avatar: user4Image,
    message: 'Menberu sent you a message',
    date: '3 min ago',
  },
  {
    id: 2,
    avatar: user3Image,
    message: 'Miki mentioned you here',
    date: '1 hour ago',
  },
  {
    id: 3,
    avatar: user2Image,
    message: 'Hanna signed up',
    date: '3 days ago',
  },
];
